import React from 'react';
import { coreAdminApiBalanceApi } from '../api';
import { StatItem } from './statItem';
import { Price } from './price';

export const SmsBalance: React.FC = () => {
  const { data, isLoading } = coreAdminApiBalanceApi.endpoints.getApiBalance.useQuery();
  return <StatItem isLoading={isLoading} label="smsc" title="Текущий баланс SMSC" value={<Price integer value={data?.sms} />} />;
};
